import axios from 'axios'
let instance = axios.create();
import store from '@/store'
import { showToast } from 'vant'
import md5 from 'js-md5'
// 判断是否是微信内打开的方法
const isWechat = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua);
};


// 根据环境变量判断正式环境还是测试环境
const isProd = process.env.NODE_ENV === 'production';
instance.defaults.baseURL = 'https://xhnapi2.voc.com.cn'
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
     let timer = new Date().getTime();
     config.headers['RMT-Request-Time'] = timer
    config.headers['RMT-Device-Type'] = 'mobile'
    config.headers['RMT-Hash'] = md5('C50GIK6GDhQNjtMRVRoQbwxVovXCX8DU' + 'v5' + 'mobile' + timer)
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    if(response.data.state_code == 1){
        return response
    }else{
        showToast({
            message:response.data.message,
            duration:1000
        })
        return false
    }
    // 对响应数据做点什么  
}, function (error) {
    // 对响应错误做点什么
    console.log('--- 401 res error response ---')
    console.log(error)
    return Promise.reject(error)
})
export default instance